import { useEffect, useState } from "react";
import {
  styled,
  Paper,
  Box,
  Button,
  CircularProgress,
  Stack,
  Dialog,
} from "@mui/material";
import { ErrorMessage, Field, Formik } from "formik";
import { H3, Span } from "components/typography/Typography";
import { formInput, initialValues, customerValidationSchema } from "./data";
import * as _ from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { createRequest, getMerchantById } from "services/https/fetchers";
import { useDispatch } from "react-redux";
import { notifySuccess } from "redux/actions/AlertActions";
import { createNewCustomer } from "services/https/paymentLink";

const FormRoot = styled(Paper)(({ theme }) => ({
  width: "50%",
  margin: `${theme.spacing(2)} auto`,
}));

const StyledBox = styled("div")(({ theme }) => ({
  ".Mui-focused": {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: "4px",
  },
  label: {
    display: "block",
    marginBlock: theme.spacing(2),
    fontWeight: "bold",
  },
  ["select,input,textarea"]: {
    width: "100%",
    borderRadius: "4px",
    padding: theme.spacing(2),
    border: "2px solid #f6f6f6",
  },
  span: {
    color: theme.palette.primary.main,
  },
}));

export const CreateCustomer = ({ openDialog, setOpenDialog }) => {
  const { userId } = useParams();
  const [merchantId, setMerchantId] = useState();
  useEffect(() => {
    getMerchantById({ userId }).then((data) => {
      const { merchantID } = data || {};
      setMerchantId(merchantID);
    });
  }, [userId]);

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": { width: "50vw", maxWidth: "50vw" },
      }}
    >
      <FormContent merchantId={merchantId} handleClose={handleClose} />
    </Dialog>
  );
};

const FormContent = ({ merchantId, handleClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={customerValidationSchema}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);

        const val = {
          ...values,
          merchantId,
        };
        //createNewCustomer({ customer: val })
        let d = new Date()
        let payload = {
         customerName: `${val?.firstName} ${val?.lastName}`,
         payload: JSON.stringify(val),
         requestId: d.getTime(),
         requestType: "createNewCustomer"
       }

       createRequest(payload)
       .then((data) => {
            setSubmitting(false);
            dispatch(
              notifySuccess({
                msg: `CUSTOMER CREATED SUCCESSFULLY`,
              })
            );
          })
          .catch(() => {
            dispatch(
              notifySuccess({
                msg: `Email already exist`,
              })
            );
          })
          .finally(() => {
            handleClose();
            navigate(-1);
          });
      }}
    >
      {({ handleSubmit, isSubmitting, errors, values }) => (
        <form onSubmit={handleSubmit}>
          <FormRoot>
            <H3
              sx={{
                p: 2,
                textAlign: "center",
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.15)",
                borderRadius: "5px",
              }}
            >
              {"Create New Customer"}
            </H3>
            {formInput.map((i, idx) => (
              <Box sx={{ m: 4 }} key={idx}>
                {i.elements ? (
                  <>
                    <label>{i.label}</label>
                    <StyledBox sx={{ display: "flex" }}>
                      {i.elements.map(({ type, options, placeholder, name }) =>
                        type === "select" ? (
                          <Field
                            as="select"
                            name={name}
                            style={{
                              height: "52px",
                              width: `${
                                name === "countryCode" ? "100px" : "100%"
                              }`,
                              marginRight: "8px",
                            }}
                          >
                            {options.map(({ name, value }) => (
                              <option name={name} value={value}>
                                {name}
                              </option>
                            ))}
                          </Field>
                        ) : (
                          <Box>
                            <Field name={name} placeholder={""} />
                            <ErrorMessage name={"phoneNumber"} />
                          </Box>
                        )
                      )}
                    </StyledBox>
                    <Span color={"primary.main"}>
                      <ErrorMessage name={"payableAmount"} />
                    </Span>
                  </>
                ) : i.type === "textArea" ? (
                  <StyledBox>
                    <label>{i.label}</label>
                    <Field as="text-area" name={i.name} />
                  </StyledBox>
                ) : (
                  <StyledBox>
                    <label>{i.label}</label>
                    <Field name={i.name} placeholder={i.placeholder} />
                    <Span>
                      <ErrorMessage name={i.name} />
                    </Span>
                  </StyledBox>
                )}
              </Box>
            ))}

            <Stack
              direction={"row"}
              sx={{ justifyContent: "space-between", p: 4 }}
            >
              <Button
                variant={"contained"}
                sx={{ mr: 2 }}
                onClick={() => {
                  handleClose();
                  navigate(-1);
                }}
              >
                {"Cancel"}
              </Button>
              <Button variant={"contained"} type={"submit"}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span>{"Create New Customer"}</span>
                  {isSubmitting ? (
                    <CircularProgress
                      sx={{ color: "#fff", marginLeft: "5px" }}
                      size={20}
                    />
                  ) : (
                    ""
                  )}
                </Box>
              </Button>
            </Stack>
          </FormRoot>
        </form>
      )}
    </Formik>
  );
};
